import { DropZone, useDragContext } from "../DragContext";
import { AddElementZone } from "../Elements/AddElementZone";
import { useHover } from "../HoverContext";
import { moveNodeOnDrop } from "../moveNodeOnDrop";
import { NodeActions } from "../NodeActions";
import {  HoverLabel, moveNodeAction } from "../Renderer";
import { useSelection } from "../SelectionContext";
import { ElementRenderer } from "./ElementRenderer";



export function CardRenderer({ card, page, setPage ,section,container }) {
 const { draggingNodeIdRef, setHoverTarget } = useDragContext();
    
function dropBetween(page, setPage, targetId, position) {

  const sourceId = draggingNodeIdRef.current;

  if (!sourceId || sourceId === targetId) return;

  setPage(prev => {
    const updated = moveNodeOnDrop(prev, sourceId, targetId, position);
    return updated;
  });

  setHoverTarget(null);
  draggingNodeIdRef.current = null;
}
  const { selectedNodeId, setSelectedNodeId } = useSelection();
  const { hoverNodeId, setHoverNodeId } = useHover();

  const isSelected = selectedNodeId === card.id;
  const isHover = hoverNodeId === card.id;

const sp = card?.styles?.custom?.spacing || {};
  const style = {
    border: "1px solid #eee",
   gap:10,
    outline: isSelected
      ? "2px solid #1A73E8"
      : isHover
      ? "2px dashed rgba(26,115,232,0.45)"
      : "none",
    outlineOffset: 2,
    cursor: "pointer",
    position: "relative"
  };

style.marginRight = sp.marginRight;
style.marginLeft = sp.marginLeft;

style.paddingTop = sp.paddingTop;
style.paddingRight = sp.paddingRight;
style.paddingLeft = sp.paddingLeft;
  return (
    <div
    draggable
  onDragStart={(e) => {
    e.dataTransfer.setData("nodeId", card.id);
    e.dataTransfer.setData("type", "card");
  }}
  onDragOver={(e) => e.preventDefault()}
  onDrop={(e) => {
    const sourceId = e.dataTransfer.getData("nodeId");
    moveNodeAction(sourceId, card.id,setPage); // We'll implement this smartly
  }}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        setSelectedNodeId(card.id);
      }}
      onMouseEnter={() => setHoverNodeId(card.id)}
      onMouseLeave={() => { // Only clear hover if not selected
    if (selectedNodeId !== card.id) setHoverNodeId(null);}}
    >
      <HoverLabel id={card.id} />

      <NodeActions nodeId={card.id} page={page} setPage={setPage} />

      {card.elements.map((el,index) => (
      
          <div key={el.id} style={{position:"relative"}} >
             {/* BEFORE drop zone */}
    
   
             <AddElementZone
      sectionId={section.id}
      containerId={container.id}
      cardId={card.id}
      index={index}
       page={page}
       setPage={setPage} 
    /><DropZone
      targetKey={`${el.id}-before`}
      onDropHere={() =>
        dropBetween(page, setPage,el.id, "before")
      }
    /> 
          <ElementRenderer element={el} page={page} setPage={setPage} />
           {/* AFTER drop zone */}
    {index === card.elements.length - 1 && (
      <DropZone
        targetKey={`${el.id}-after`}
        onDropHere={() =>
          dropBetween(page, setPage,el.id, "after")
        }
      />
    )}
        {index === card.elements.length - 1 && (
      <AddElementZone
        sectionId={section.id}
        containerId={container.id}
        cardId={card.id}
        index={index + 1}
        page={page}
        setPage={setPage} 
      />
    )}

    
        </div>
      ))}
    </div>
  );
}
